import { useState } from "react";
import "@google/model-viewer";
import { PopoverComponent } from "./Extras";
import { Typography } from "@mui/material";

function canPreviewData(data) {
    if (!data)
        return false;
    let type = data.type ?? data.part_type;
    if (type === "Parts" || type === "Trim" || type === "None" || !type)
        return false;
    return true;
}

const POPreviewView = ({data, counter}) => {
    const [previewURL, setPreviewURL] = useState(null);
    function roundAtThree(text) {
        const fl = parseFloat(text);
        if(fl) {
            if(String(text).includes("."))
                return `${fl.toPrecision(3)}`;
        }
        return text;
    }

    function serializeForURL(obj) {
        var str = [];
        var params = {};
        let defaults = obj?._defaults || {};
        for(var p in defaults)
            params[p] = defaults[p];
        for(var p in obj)
            params[p] = obj[p];
        console.log(params);
        for(var p in params) {
            if(p === "_conditions") continue;
            let value = params[p];
            if(typeof value === 'object') {
                for(var x in value) {
                    str.push(encodeURIComponent(`${p}____${x}`) + "=" + encodeURIComponent(roundAtThree(value[x])));
                }
            } else {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(roundAtThree(value)));
            }
           
        }
        return str.join("&");
    }
      
    function createPreviewURL(fmt, props, counter) {
        var prop_str = serializeForURL(props);
        return `${process.env.REACT_APP_API_URL}v1/3dpreview/preview?format=${fmt}&${prop_str}&dummy_counter=${counter}`;
    }

    if(!canPreviewData(data))
        return <Typography>Preview with selected options is not currently available.</Typography>;

    return <model-viewer style={{width: 550, height: 550}}
            src={createPreviewURL("glb", data, counter)}
            camera-controls
            camera-target={"0m 0m 0m"}
            camera-orbit={"70deg 70deg 100%"}
            disable-tap={true}
            shadow-intensity={1}
            touch-action={"pan-y"}
            environment-image={"https://cdn.shopify.com/s/files/1/0688/0641/0547/files/small.hdr"}
            exposure={2.2}
            tone-mapping={"commerce"}
    />
}

export {POPreviewView, canPreviewData}
